import sleep from '@anm/helpers/sleep';
import { VideoStatusCode } from '@anm/hosting-player';
import { useEffect } from 'react';

import routes from '../../../../routes';
const { Router } = routes;

const useRedirectToError = (errorCode?: VideoStatusCode) => {
  const isErrorHandled =
    errorCode === VideoStatusCode.in_process ||
    errorCode === VideoStatusCode.processingError ||
    errorCode === VideoStatusCode.no_video ||
    errorCode === VideoStatusCode.blocked ||
    errorCode === VideoStatusCode.codecErorr;

  const redirectToError = async () => {
    await sleep(0);
    Router.pushRoute('404');
  };

  useEffect(() => {
    const canRedirectToError = errorCode && !isErrorHandled;

    canRedirectToError && redirectToError();
  }, [errorCode, isErrorHandled]);
};

export default useRedirectToError;
